<aside #sidebarEl
       class="sidebar"
       [class.open]="isOpen"
       [class.closed]="!isOpen"
       (mouseleave)="onSidebarMouseLeave()">
  <!-- Root items; submenus at any depth are rendered by the flyout. -->
  <nav class="sidebar-nav" aria-label="Menu principal">
    <ul class="menu-list" role="menubar" aria-orientation="vertical">
      <ng-container *ngIf="!menuLoading">
        <ng-container *ngFor="let item of menuItems; let i = index; trackBy: trackByItem">
        <li *ngIf="item.key === 'comunicacao'"
            class="menu-divider"
            role="separator"
            aria-hidden="true"></li>
        <li class="menu-item"
            role="none"
            [class.has-children]="hasChildren(item)">
          <a
            #rootLink
            [routerLink]="!hasChildren(item) && item.route ? item.route : null"
            [routerLinkActive]="!hasChildren(item) && item.route ? 'active' : ''"
            [routerLinkActiveOptions]="{ exact: false }"
            [class.is-open]="isOpenRoot(item)"
            [class.is-on-active-path]="isOnActivePath(item)"
            class="menu-link"
            role="menuitem"
            [attr.tabindex]="rootTabIndex(item)"
            [attr.data-item-id]="itemKey(item)"
            [attr.aria-haspopup]="hasChildren(item) ? 'menu' : null"
            [attr.aria-expanded]="hasChildren(item) ? isOpenRoot(item) : null"
            (click)="onRootClick(item, $event)"
            (keydown)="onRootKeydown(item, $event, i)"
            (mouseenter)="onRootMouseEnter(item, $event)"
            (mouseleave)="onRootMouseLeave($event)">

            <span class="menu-icon">
              <lucide-icon [name]="getLucideIcon(item.iconSvg)" [size]="20"></lucide-icon>
            </span>

            <span class="menu-label">{{ item.label }}</span>

            <span *ngIf="hasChildren(item)" class="menu-chevron" aria-hidden="true">
              <lucide-icon name="chevron-right" [size]="16"></lucide-icon>
            </span>
          </a>
        </li>
        </ng-container>
      </ng-container>
      <li *ngIf="menuLoading" class="menu-item menu-loading" role="none">
        <span class="menu-link" role="menuitem">{{ 'layout.sidebar.loading' | translate }}</span>
      </li>
    </ul>
  </nav>

  <!-- Sticky footer at the end of the menu: Terms, Privacy, Logout always visible. -->
  <div class="sidebar-footer">
    <a routerLink="/legal/termos" target="_blank" rel="noopener" class="footer-link">{{ 'layout.sidebar.footer.terms' | translate }}</a>
    <a routerLink="/legal/privacidade" target="_blank" rel="noopener" class="footer-link">{{ 'layout.sidebar.footer.privacy' | translate }}</a>
    <a href="#" class="footer-link footer-link-logout" (click)="logout($event)">
      <span class="footer-link-logout-icon" aria-hidden="true">&lt;</span>
      {{ 'layout.sidebar.footer.logout' | translate }}
    </a>
  </div>
</aside>

<!-- Root flyout, outside <aside> so it escapes the sidebar's overflow:hidden.
     Both close requests land on the same handler because the sidebar only ever
     sees the outermost level: "close this level" (ArrowLeft on the level-1
     panel) and "close the cascade" (Esc, at any depth) mean the same thing here.
     The two differ INSIDE the cascade, where closeRequested stops at the level
     above and closeAllRequested keeps travelling up. -->
<app-nav-flyout
  *ngIf="openItem && openItem.children?.length"
  [items]="openItem.children!"
  [anchor]="openAnchor"
  [activePath]="activePath"
  [currentUrl]="currentUrl"
  [autofocus]="flyoutAutofocus"
  (itemActivated)="onLeafActivated($event.item, $event.fromKeyboard)"
  (closeRequested)="onFlyoutClose()"
  (closeAllRequested)="onFlyoutClose()">
</app-nav-flyout>
